















import Vue from "vue";
import LabeledButton from "./LabeledButton.vue";

export default Vue.extend({
  name: "LabeledButtonWithDialog",
  components: {
    LabeledButton
  },
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    nw: String,
  },
  data: () => ({
      dialog: { show: false },
    }),
  methods: {
    closeDialog() {
      this.dialog.show = false
    }
  }
});
